import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1225.982 926.244c27.296 18.796 27.3 49.268 0 68.067l-509.835 351.074c-27.297 18.796-49.425 7.18-49.425-25.96V601.13c0-33.133 22.125-44.758 49.425-25.96l509.835 351.075z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconMiniArrowEndSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconMiniArrowEndSolid, _Component);

  var _super = _createSuper(IconMiniArrowEndSolid);

  function IconMiniArrowEndSolid() {
    _classCallCheck(this, IconMiniArrowEndSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconMiniArrowEndSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconMiniArrowEnd",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconMiniArrowEndSolid.displayName = "IconMiniArrowEndSolid";
  return IconMiniArrowEndSolid;
}(Component);

IconMiniArrowEndSolid.glyphName = 'mini-arrow-end';
IconMiniArrowEndSolid.variant = 'Solid';
IconMiniArrowEndSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconMiniArrowEndSolid;
export { IconMiniArrowEndSolid };